// extracted by mini-css-extract-plugin
export var required = "_oy-0";